import type { TrustIcon } from '@widget/core';

export type TrustIconsProps = {
  trustIconsList: TrustIcon[];
  autoSize?: boolean;
  height?: string;
  width?: string;
};

export const TrustIcons = ({
  trustIconsList,
  autoSize = false,
  width,
  height,
}: TrustIconsProps): JSX.Element => {
  const onTrustIconClick = (icon: TrustIcon): void => {
    if (icon.link?.url) {
      window.open(icon.link.url, '_blank');
    }
  };

  return (
    <>
      {trustIconsList.map((icon) => {
        return (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <span
            css={{ cursor: 'pointer' }}
            key={icon.image?.url}
            onKeyDown={() => onTrustIconClick(icon)}
            onClick={() => onTrustIconClick(icon)}
          >
            <img
              css={{ verticalAlign: 'top' }}
              src={icon.image?.url || ''}
              alt={icon.imageAlt || ''}
              width={autoSize ? width || 'auto' : icon.imageWidth || ''}
              height={autoSize ? height || 'auto' : icon.imageHeight || ''}
            />
          </span>
        );
      })}
    </>
  );
};
